import { useTranslation } from 'next-i18next';
import { usePdp } from '@context/PdpContext';
import NumberInput from '_components/UI/NumberInput';
import { FEATURE_FLAG_PDP_MIN_PURCHASE_QUANTITY } from '@config/feature-flag';

import styles from './QuantitySelector.module.scss';

const QuantitySelector = () => {
  const { quantity, setQuantity, minPurchaseQuantity } = usePdp();
  const { t } = useTranslation(['common', 'pdp']);

  const shouldMinQuantityMessage =
    FEATURE_FLAG_PDP_MIN_PURCHASE_QUANTITY && minPurchaseQuantity;

  return (
    <div className={styles.container}>
      <>
        {shouldMinQuantityMessage && (
          <div className={styles.minQuantityMessage}>
            <div>{t('pdp:product.soldByBoxesOf', { minPurchaseQuantity })}</div>
            <div>{t('pdp:product.soldByBoxesOf.inStore')}</div>
          </div>
        )}
        <label className={styles.label} htmlFor="productQuantitySelector">
          {t('pdp:product.quantity.label')}
        </label>
        <NumberInput
          value={quantity}
          minValue={minPurchaseQuantity ?? 1}
          handleUpdate={setQuantity}
          inputName="productQuantitySelector"
          inputId="productQuantitySelector"
          inputAriaLabel={t('common:cart.quantity.field')}
          decreaseAriaLabel={t('common:cart.quantity.decrease')}
          increaseAriaLabel={t('common:cart.quantity.increase')}
          minIncrement={minPurchaseQuantity}
        />
      </>
    </div>
  );
};

export default QuantitySelector;
